import React, {Component} from "react"
import verge from 'verge'
import {injectIntl} from 'react-intl'
import {Dropdown} from 'react-bootstrap'
import {Link} from "react-router"
import LanguageSelect from "../../components/LanguageSelect"
import NavBar from "./NavBar"
import classes from "./CoreLayout.scss"
import "../../styles/core.scss"
import {connect} from "react-redux"
import $ from 'jquery'
import {predicateFunctions} from '../../routes/AuthWrappers'
import {EVENT_OPEN_ACCOUNT_SELECTION_MODAL, getAvailableApplications, getCurrentYear} from "../../constants"
import {queryUserInfo, setCurrentAccount, setCurrentApplication} from "../../dispatch"
import EnterpriseAccountSelectionModal from "../../routes/enterprise/components/EnterpriseAccountSelectionModal"
import FullScreenWarningModal from "../../components/FullScreenWarningModal"
import ApplicationIcon from "../../components/ApplicationIcon"
import {RxEmitter} from "rxemitter"
import moment from "moment"


function mapStateToProps(state, ownProps) {


  const user = state.user
  return {
    location: state.router.locationBeforeTransitions,
    user
  }
}

const mapDispatchToProps = {
  queryUserInfo,
  setCurrentAccount,
  setCurrentApplication
}

class CoreLayout extends Component {

  constructor() {
    super()
    this.state = {
      accountModalOpen: false,
      width: 0, height: 0
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  }

  componentWillMount() {
    RxEmitter.on(EVENT_OPEN_ACCOUNT_SELECTION_MODAL).subscribe((x) => {
      console.log('on EVENT_OPEN_ACCOUNT_SELECTION_MODAL')
      this.openAccountModal()
    });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);


  }

  updateWindowDimensions() {
    this.setState({width: verge.viewportW(), height: verge.viewportH()});
  }

  openAccountModal = () => {
    this.setState({accountModalOpen: true})
  }
  closeAccountModal = () => {
    this.setState({accountModalOpen: false})
  }

  render() {
    const pathname = this.props.location.pathname
    const isAdminPortal = pathname.startsWith('/admin')

    const formatMessage = this.props.intl.formatMessage

    const user = this.props.user
    const applications = getAvailableApplications(user)
    const setApplication = this.props.setCurrentApplication

    const currentApplication = user.currentApplication?user.currentApplication:applications[0]

    const applicationSelectBar = predicateFunctions['UserIsEnterprise'](user) && !isAdminPortal ?


        applications.map(app => {

          const active = currentApplication.id === app.id
          return (active ?
            <li><ApplicationIcon application={app} active={active}/></li>
            :
            <li><Link to={`/enterprise${app.name === 'memorie'?'':`/${app.name}`}/dashboard`}
                  onClick={e => {
                    if (app) {
                      setApplication(app)
                    }

                  }}>
              <ApplicationIcon application={app} active={active}/>
            </Link></li>)
        })

      : ""

    const enterpriseButton = predicateFunctions['UserIsEnterprise'](user) ?
      <li>
        <Link style={{color: '#999c9e', fontWeight: 'bold', position: 'relative'}}
              aria-expanded="false" role="button" to='/enterprise' bsRole="toggle"
              onClick={(e) => {
                this.openAccountModal()
                e.preventDefault()
              }}>

          <i style={{marginLeft: '6px'}} className="fa fa-share"></i>
          {isAdminPortal?"Go to Enterprise Account ...":<strong>{user.currentEnterpriseAccount ? user.currentEnterpriseAccount.name : ''}</strong>}
        </Link>
      </li>
      : ""

    const enterpriseDropDown = predicateFunctions['UserIsEnterprise'](user) ?
      <li>
        <Dropdown id="dropdown-custom-menu" style={{display: 'block'}}>
          <Link activeClassName={classes.activeLink}
                style={{color: '#999c9e', fontWeight: 600, position: 'relative'}}
                aria-expanded="false" role="button" to='/enterprise' bsRole="toggle"
                onClick={(e) => {
                  this.props.queryUserInfo()
                  e.preventDefault()
                }}>
            <i style={{marginRight: '6px'}} className="fa fa-building-o"></i>
            {formatMessage({id: 'nav.enterprise'})}
          </Link>
          <ul className="dropdown-menu dropdown-alerts" bsRole="menu" style={{width: '200px'}}>
            {_.sortBy(user.employers, (it) => it.name).map(
              (e) => (
                <li>
                  <Link to={`/enterprise/dashboard`} onClick={() => {
                    this.props.setCurrentAccount(e.id)
                    const toggle = $('#dropdown-custom-menu')[0]
                    toggle.dropdown('toggle')

                  }}>
                    <div>
                      <i className="fa fa-building fa-fw"></i> {e.name}
                    </div>
                  </Link>
                </li>
              )
            )}
          </ul>
        </Dropdown>
      </li>
      : ""

    const adminLink = isAdminPortal?
      <li>
        <div className="p-md">
          <i className="fa fa-info-circle m-r-xs"/>
          You are now in Neeuro Admin View
        </div>
      </li>:
      (predicateFunctions['UserIsAdminOrOps'](user) ?
      <li>
        <Link aria-expanded="false" role="button" to="/admin">
          <i className="fa fa-university"></i>
          {formatMessage({id: 'nav.go.to.admin'})}
        </Link>
      </li>
      : "")

    const userLink =
      <li>
        <Link activeClassName={classes.activeLink} aria-expanded="false" role="button" to="/user">
          <i className="fa fa-user"></i>
          User
        </Link>
      </li>

    const enterpriseAccountName =
      user.currentEnterpriseAccount ?
        <li>
        <span className="m-r-sm text-muted welcome-message">
          {formatMessage({id: 'current.account'})}: <strong>{user.currentEnterpriseAccount.name}</strong>
        </span>
        </li>
        : ""

    const style = {minWidth: 767}


    // if(isAdminPortal) style.backgroundColor = '#931D4D'
    return (

      <div id="wrapper" style={style}>

        <EnterpriseAccountSelectionModal
          show={this.state.accountModalOpen}
          onHide={this.closeAccountModal}
        />

        <FullScreenWarningModal show={this.state.width < 768}/>

        <NavBar/>

        <div id="page-wrapper" className="gray-bg">
          <div className="row border-bottom">

            <nav className="navbar navbar-static-top" role="navigation" style={{marginBottom: 0}}>
              <ul className="nav navbar-top-links navbar-left m-l-lg">
                {adminLink}
              </ul>
              <ul className="nav navbar-top-links navbar-right">
                {enterpriseButton}
              </ul>

            </nav>
          </div>

          <div style={{padding: '0px 0px 40px 0px'}}>
            {this.props.children}
          </div>

          <div className="footer">
            <div className="pull-right">
              <LanguageSelect/>
            </div>
            <div>
              <strong>Copyright</strong> Neeuro Pte Ltd &copy; {getCurrentYear()}
            </div>
          </div>

        </div>
      </div>

    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CoreLayout))



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js